// src/useStore.js

import { create } from "zustand";
import { fetchLogin } from "./Services/fetchlogin";
import { fetchUsers } from "./Services/fetchUsers";
import { fetchUserRoutes } from "./Services/fetchUserRoutes";
import { fetchAddUser } from "./Services/fetchAddUser";
import { fetchChangePassword } from "./Services/fetchChangePassword";
import { fetchPasswordHistory } from "./Services/fetchPasswordHistory";

const useStore = create((set) => ({
  // — Estado global —
  loading: false,
  error: null,
  users: [],
  userRoutes: [],
  routesLoading: false,

  // — Reset de error —
  resetError: () => {
    set({ error: null });
  },

  // — Vacía userRoutes antes de un nuevo fetch —
  clearUserRoutes: () => {
    set({ userRoutes: [] });
  },

  // — Login (si aplica) —
  fetchDataLogin: async (body) => {
    set({ loading: true, error: null });
    try {
      await fetchLogin(body);
      set({ loading: false });
    } catch (error) {
      set({ error: error, loading: false });
    }
  },

  // — Traer la lista de usuarios —
  fetchUsersData: async () => {
    set({ loading: true, error: null });
    try {
      const data = await fetchUsers();
      set({ users: data, loading: false });
    } catch (error) {
      set({ error: error, loading: false });
    }
  },

  // — Traer las rutas de “username” para una fecha —
fetchUserRoutesData: async (username, filterDate = "") => {
  // solo reseteamos userRoutes, dejamos routeDays intactos mientras carga
  set({ routesLoading: true, error: null, userRoutes: [] });

  try {
    const { items, routeDays } = await fetchUserRoutes(username, null, filterDate);

    set({
      userRoutes: items,
      routeDays: routeDays || [], // si viene vacío lo reemplaza; si no viene nada, se queda lo previo
      routesLoading: false,
    });
  } catch (error) {
    // en caso de error verdadero (no el 404 manejado arriba), no barres routeDays
    set({ error, routesLoading: false });
  }
},



  // — Agregar usuario —
  fetchAddUserData: async (body) => {
    set({ loading: true, error: null });
    try {
      const result = await fetchAddUser(body);
      set({ loading: false });
      return result;
    } catch (error) {
      set({ error: error, loading: false });
      throw error;
    }
  },

  // — Cambiar contraseña —
  fetchChangePasswordData: async (username, currentPassword, newPassword) => {
    set({ loading: true, error: null });
    try {
      const result = await fetchChangePassword(
        username,
        currentPassword,
        newPassword
      );
      set({ loading: false });
      return result;
    } catch (error) {
      set({ loading: false, error });
      throw error;
    }
  },

  // — Historial de contraseñas —
  fetchPasswordHistoryData: async (username) => {
    set({ loading: true, error: null });
    try {
      const history = await fetchPasswordHistory(username);
      set({ loading: false });
      return history || [];
    } catch (error) {
      set({ loading: false });
      return [];
    }
  },
}));

export default useStore;
